/*
  使用elementUi为底层编写的组件
  命名方式为 lu-***-***
*/
import luDragSelect from "@/packages/lu/lu-drag-select";
import luMarkdown from "@/packages/lu/lu-markdown";
import luTableSelected from "@/packages/lu/lu-table-selected";
import luBatchInput from "@/packages/lu/lu-batch-input";
import luUploadFile from "@/packages/lu/lu-upload-file";
import luCountTo from "@/packages/lu/lu-count-to";
import luSaasTable from "@/packages/lu/lu-saas-table";
import luPreview from "@/packages/lu/lu-image-preview";
import luSaasSearch from "@/packages/lu/lu-saas-search";
//element-ui插件
import {
  luDialog,
  luPagination,
  luNotification,
  luMessage,
  luScrollbar,
  luMessageBox,
  luLoading,
  luFooter,
  luMain,
  luAside,
  luHeader,
  luContainer,
  luTransfer,
  luColorPicker,
  luCollapseItem,
  luCollapse,
  luCarousel,
  luCarouselItem,
  luCascader,
  luStep,
  luSteps,
  luRate,
  luCard,
  luBadge,
  luProgress,
  luUpload,
  luCol,
  luRow,
  luIcon,
  luSlider,
  luAlert,
  luTree,
  luPopover,
  luTimePicker,
  luTimeSelect,
  luDatePicker,
  luTableColumn,
  luTable,
  luButtonGroup,
  luButton,
  luTag,
  luTabPane,
  luTabs,
  luFormItem,
  luForm,
  luBreadcrumbItem,
  luBreadcrumb,
  luAutocomplete,
  luDropdown,
  luDropdownMenu,
  luDropdownItem,
  luMenu,
  luSubmenu,
  luMenuItem,
  luMenuItemGroup,
  luInput,
  luInputNumber,
  luRadio,
  luRadioGroup,
  luRadioButton,
  luCheckbox,
  luCheckboxButton,
  luCheckboxGroup,
  luSwitch,
  luSelect,
  luOption,
  luOptionGroup,
  luTooltip
} from "./commons";

const components = [
  //自定义组件
  luDragSelect,
  luMarkdown,
  luTableSelected,
  luBatchInput,
  luUploadFile,
  luCountTo,
  luSaasTable,
  luSaasSearch,
  luPreview,
  //element组件库
  luDialog,
  luScrollbar,
  luPagination,
  luNotification,
  luMessage,
  luMessageBox,
  luLoading,
  luFooter,
  luMain,
  luAside,
  luHeader,
  luContainer,
  luTransfer,
  luColorPicker,
  luCollapseItem,
  luCollapse,
  luCarousel,
  luCarouselItem,
  luCascader,
  luStep,
  luSteps,
  luRate,
  luCard,
  luBadge,
  luProgress,
  luUpload,
  luCol,
  luRow,
  luIcon,
  luSlider,
  luAlert,
  luTree,
  luPopover,
  luTimePicker,
  luTimeSelect,
  luDatePicker,
  luTableColumn,
  luTable,
  luButtonGroup,
  luButton,
  luTag,
  luTabPane,
  luTabs,
  luFormItem,
  luForm,
  luBreadcrumbItem,
  luBreadcrumb,
  luAutocomplete,
  luDropdown,
  luDropdownMenu,
  luDropdownItem,
  luMenu,
  luSubmenu,
  luMenuItem,
  luMenuItemGroup,
  luInput,
  luInputNumber,
  luRadio,
  luRadioGroup,
  luRadioButton,
  luCheckbox,
  luCheckboxButton,
  luCheckboxGroup,
  luSwitch,
  luSelect,
  luOption,
  luOptionGroup,
  luTooltip
];

const install = function(Vue) {
  components.forEach(component => {
    if (component.name) {
      if (component.name.indexOf("El") != -1) {
        component.name = component.name.replace("El", "lu");
      }
      Vue.component(component.name, component);
    }
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  luDragSelect,
  luMarkdown,
  luTableSelected,
  luBatchInput,
  luUploadFile,
  luCountTo,
  luSaasTable,
  luSaasSearch,
  luPreview,
  //elementUI组件库引用
  luScrollbar,
  luDialog,
  luPagination,
  luNotification,
  luMessage,
  luMessageBox,
  luLoading,
  luFooter,
  luMain,
  luAside,
  luHeader,
  luContainer,
  luTransfer,
  luColorPicker,
  luCollapseItem,
  luCollapse,
  luCarousel,
  luCarouselItem,
  luCascader,
  luStep,
  luSteps,
  luRate,
  luCard,
  luBadge,
  luProgress,
  luUpload,
  luCol,
  luRow,
  luIcon,
  luSlider,
  luAlert,
  luTree,
  luPopover,
  luTimePicker,
  luTimeSelect,
  luDatePicker,
  luTableColumn,
  luTable,
  luButtonGroup,
  luButton,
  luTag,
  luTabPane,
  luTabs,
  luFormItem,
  luForm,
  luBreadcrumbItem,
  luBreadcrumb,
  luAutocomplete,
  luDropdown,
  luDropdownMenu,
  luDropdownItem,
  luMenu,
  luSubmenu,
  luMenuItem,
  luMenuItemGroup,
  luInput,
  luInputNumber,
  luRadio,
  luRadioGroup,
  luRadioButton,
  luCheckbox,
  luCheckboxButton,
  luCheckboxGroup,
  luSwitch,
  luSelect,
  luOption,
  luOptionGroup,
  luTooltip
};
